import { useState, useRef, useEffect } from "react";
import {
  Container,
  HamburgerButton,
  Menu,
  MenuItem,
} from "./MyAccountOptions.styled";
import { useUserDataContext } from "../../../contexts/UserDataContext";
import { useAccountContext } from "../../../contexts/Account";
import { useLoginStageContext } from "../../../contexts/LoginStageContext";

export function MyAccountOptions() {
  const { loggedInUserCognitoIdToken, setMyAccountOpen, impersonatedUserId, stopImpersonation } = useAccountContext();
  const { logoutUser, setCheckoutPopupOpen } = useUserDataContext();
  const { setLoginStage } = useLoginStageContext();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const isLoggedIn =
    loggedInUserCognitoIdToken !== "" && loggedInUserCognitoIdToken !== null;

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    const handleScroll = () => {
      setIsOpen(false);
    };

    const handleKeyDown = () => {
      setIsOpen(false);
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      window.addEventListener("scroll", handleScroll);
      document.addEventListener("keydown", handleKeyDown);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("keydown", handleKeyDown);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  function handleWithModalClose(action: () => void): () => void {
    return () => {
      action();
      toggleMenu();
    };
  }

  function handleStopImpersonation() {
    if (window.confirm("Stop impersonating and return to your account?")) {
      stopImpersonation();
      window.location.reload();
    }
  }

  return (
    <Container ref={menuRef}>
      {isLoggedIn ? (
        <>
          <HamburgerButton $isOpen={isOpen} onClick={toggleMenu}>
            <div />
            <div />
            <div />
          </HamburgerButton>

          {isOpen && (
            <Menu>
              <MenuItem
                onClick={handleWithModalClose(() => setMyAccountOpen(true))}
              >
                Account Details
              </MenuItem>
              <MenuItem
                onClick={handleWithModalClose(() => setCheckoutPopupOpen(true))}
              >
                Subscription Details
              </MenuItem>
              {impersonatedUserId && (
                <MenuItem
                  onClick={handleWithModalClose(handleStopImpersonation)}
                  style={{ color: "#b45309", fontWeight: 700 }}
                >
                  Stop Impersonation
                </MenuItem>
              )}
              <MenuItem onClick={handleWithModalClose(() => logoutUser())}>
                Logout
              </MenuItem>
            </Menu>
          )}
        </>
      ) : (
        <button
          onClick={() => setLoginStage("login")}
          style={{
            borderRadius: '30px',
            border: 'none',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.15)',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '700',
            padding: '0px 20px',
            height: '30px',
            color: '#608cdf',
            backgroundColor: '#ffffff',
            transition: 'all 0.2s ease',
            whiteSpace: 'nowrap'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = '0.9';
            e.currentTarget.style.transform = 'scale(0.98)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          Login
        </button>
      )}
    </Container>
  );
}

export default MyAccountOptions;
